export class PulumiConfigurationsFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "eonAccountId",
            "baseName": "eonAccountId",
            "type": "EonAccountIdFilters",
            "format": ""
        },
        {
            "name": "stackName",
            "baseName": "stackName",
            "type": "StackNameFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PulumiConfigurationsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
